export default function LinkCircleIcon({
  size = 52,
  className = "text-[#067647]",
  title = "رابط",
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 52 52"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M2.5 25C2.5 12.0213 13.0213 1.5 26 1.5C38.9787 1.5 49.5 12.0213 49.5 25C49.5 37.9787 38.9787 48.5 26 48.5C13.0213 48.5 2.5 37.9787 2.5 25Z"
        fill="none"
        stroke="currentColor"
      />
      <path
        d="M33.4675 17.5975C31.7411 15.8008 28.9292 15.8008 27.2028 17.5975L26.4893 18.3401C26.2023 18.6388 26.2118 19.1136 26.5105 19.4006C26.8092 19.6876 27.284 19.6781 27.5709 19.3794L28.2845 18.6368C29.4206 17.4544 31.2497 17.4544 32.3859 18.6368C33.5382 19.8361 33.5382 21.7925 32.3859 22.9918L29.1465 26.3632C28.9668 26.5502 28.7711 26.7065 28.565 26.8332C27.4569 27.5143 26.0056 27.3629 25.0451 26.3632C24.8888 26.2006 24.7539 26.0244 24.6402 25.8381C24.4243 25.4846 23.9628 25.373 23.6092 25.5889C23.2557 25.8047 23.1441 26.2663 23.36 26.6198C23.5295 26.8975 23.7307 27.1603 23.9635 27.4025C25.418 28.9162 27.6477 29.1577 29.3504 28.1111C29.6651 27.9177 29.9603 27.6811 30.2281 27.4025L33.4675 24.0311C35.1777 22.2512 35.1776 19.3774 33.4675 17.5975Z"
        fill="currentColor"
      />
      <path
        d="M28.0368 22.5975C26.3104 20.8008 23.4984 20.8008 21.7721 22.5975L18.5326 25.9689C16.8225 27.7488 16.8225 30.6226 18.5326 32.4025C20.259 34.1992 23.0709 34.1992 24.7973 32.4025L25.5111 31.6596C25.7981 31.3609 25.7886 30.8861 25.4899 30.5991C25.1913 30.3122 24.7165 30.3216 24.4295 30.6203L23.7157 31.3632C22.5796 32.5456 20.7504 32.5456 19.6143 31.3632C18.4619 30.1639 18.4619 28.2075 19.6143 27.0082L22.8537 23.6368C23.9898 22.4544 25.819 22.4544 26.9551 23.6368C27.1113 23.7994 27.2462 23.9756 27.3599 24.1617C27.5758 24.5152 28.0374 24.6268 28.3909 24.4109C28.7444 24.195 28.856 23.7334 28.6401 23.3799C28.4706 23.1024 28.2694 22.8397 28.0368 22.5975Z"
        fill="currentColor"
      />
    </svg>
  );
}
